document.addEventListener("DOMContentLoaded", function () {
  const popularSearchElements = document.querySelectorAll(
    ".popular-search-custom",
  )
  const defaultSearchContents = document.querySelectorAll(
    ".custom-search-default",
  )

  popularSearchElements.forEach((element, index) => {
    const getSearchHtml = element.innerHTML
    defaultSearchContents.forEach((defaultContent) => {
      defaultContent.innerHTML = getSearchHtml
    })
  })

  const searchResultsContainer = document.querySelector("#ProductGridContainer")
  if (
    !searchResultsContainer ||
    searchResultsContainer?.querySelectorAll(".product-grid li")?.length === 0
  ) {
    document
      .querySelectorAll("predictive-search")
      .forEach((searchContainer) => {
        searchContainer.classList.add("show-not-result")
      })
  } else {
    document
      .querySelectorAll("predictive-search")
      .forEach((searchContainer) => {
        searchContainer.classList.remove("show-not-result")
      })
  }
})
